<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800">Email Template</h1>
                    <div class="btns-container">
                        <!-- <div class="margin-right-5">
                            <a (click)="openSendPreviewEmailModal()" class="btn btn-primary shadow-sm">
                                <i class="fas fa-envelope text-white-50"> <span class="button-text">Send Preview Email</span></i>
                            </a>
                        </div> -->
                        <div class="margin-right-5">
                            <a (click)="openPreviewEmailModal()" class="btn btn-primary shadow-sm">
                                <i class="fas fa-eye text-white-50"> <span class="button-text"> Preview</span></i>
                            </a>
                        </div>
                        <div class="margin-right-5">
                            <ng-container *ngIf="templateId!==0">
                                <a *ngIf="showDelete == false" (click)="openConfirmationModal()" class="btn btn-red shadow-sm" [ngClass]="{'disabled': isStandard}">
                                    <i class="fas fa-trash-alt text-white-50"> <span class="button-text"> Delete</span></i>
                                </a>
                            </ng-container>
                        </div>
                        <div *ngIf="isStandard" class="margin-right-5">
                            <a (click)="customize()" class="btn btn-primary shadow-sm">
                                <i class="fas fa-edit text-white-50"> <span class="button-text"> Customize</span></i>
                            </a>
                        </div>
                        <div>
                            <a (click)="saveTemplate(_name.value, _type.value, _purpose.value, '1', _userType.value )" [ngClass]="{'disabled': isStandard || savingTemplate}" class="btn btn-primary shadow-sm">
                                <i  class="text-white-50 fas" [ngClass]="{'fa-save': !savingTemplate}"> 
                                    <span class="button-text">
                                        <span *ngIf="!savingTemplate"> Save</span>
                                        <i *ngIf="savingTemplate" class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i>
                                    </span>
                                </i>
                            </a>
                        </div>
                    </div>
                </div>


                <div class="panel-group main-container col-md-12 shadow" id="mainAccordion" style="height: 50px;">
                    <!--------------------------------toolBox---------------------------------->

                    <div class="container-fluid">
                        <div class="row">

                            <!--------------------------------toolBox END----------------------------------->
                            <!--------------------------------main-content---------------------------------->
                            <div class="col-md-12">
                                <div class="main-container">

                                    <div class="panel-group" id="mainAccordion">
                                        <div class="panel panel-default">
                                            <!--fieldsTitle  // (click)="changeTitle(fieldsOpen)"-->
                                            <div class="panel-heading " id="{{fieldsOpen}}" data-toggle="collapse" data-parent="#mainAccordion" href="#collapse">
                                                <h4 class="panel-title">
                                                    <a>
                                                        Details
                                                    </a>
                                                </h4>
                                            </div>
                                            <div id="collapse" class="panel-collapse collapse in">
                                                <div class="panel-body">
                                                    <div class="panel-body">
                                                        <div class="row">
                                                            <div class="col-12 col-md-2">
                                                                <label>Name: </label>
                                                            </div>
                                                            <div class="col-12 col-md-10">
                                                                <input [disabled]="isStandard" #_name type="text" id="emailTemplateName" value="{{name}}" />
                                                            </div>
                                                        </div>

                                                        <div class="row">
                                                            <div class="col-12 col-md-2">
                                                                <label>Assessment type: </label>
                                                            </div>
                                                            <div class="col-12 col-md-10">
                                                                <select [disabled]="isStandard" id="aType" #_type>
                                                                    <option *ngFor="let _type of assessmentsTypes" [selected]="type == _type.Id" [value]="_type.Id">{{_type.Name}}</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <!--<div class="row">
                    <div class="col-12">
                        <label>Niche: </label>
                        <select [disabled]="isStandard" id="aNiche" #_niche>
                            <option *ngFor="let _niche of niches" [selected]="niche == _niche.Id" value="{{_niche.Id}}">{{_niche.Name}}</option>
                        </select>
                    </div>
                </div>-->

                                                        <div class="row">
                                                            <div class="col-12 col-md-2">
                                                                <label>User Type: </label>
                                                            </div>
                                                            <div class="col-12 col-md-10">
                                                                <select [disabled]="isStandard" id="aUserType" #_userType>
                                                                    <option *ngFor="let _usertype of userTypes" [selected]="userType == _usertype.Id" value="{{_usertype.Id}}">{{_usertype.Name}}</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div class="row">
                                                            <div class="col-12 col-md-2">
                                                                <label>Purpose: </label>
                                                            </div>
                                                            <div class="col-12 col-md-10">
                                                                <select [disabled]="isStandard" id="aPurpose" #_purpose>
                                                                    <option *ngFor="let _purpose of purposes" [selected]="purpose == _purpose.Id" value="{{_purpose.Id}}">{{_purpose.Name}}</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div class="row">
                                                            <div class="col-12 col-md-2">
                                                                <label>Language: </label>
                                                            </div>
                                                            <div class="col-12 col-md-10">
                                                                <select [disabled]="isStandard" id="languages" #_languageShortCode (change)="checkData(_languageShortCode.value, _subject.value)" (focusin)="addLocalization(_languageShortCode.value, _subject.value )">
                                                                    <option *ngFor="let _language of languages" [selected]="_language == 'en'" class="option" value="{{_language.ShortCode}}">{{_language.Name}}</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div class="row">
                                                            <div class="col-12 col-md-2">
                                                                <label>Subject: </label>
                                                            </div>
                                                            <div class="col-12 col-md-10">
                                                                <input [disabled]="isStandard" #_subject (keypress)="preventSpace(_subject.value, $event)" (keyup)="preventSpace(_subject.value, $event)" type="text" id="subject" value="" placeholder="Subject" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="panel panel-default">
                                                <div class="panel-heading" data-toggle="collapse" data-parent="#mainAccordion" href="#collapseEditor">
                                                    <h4 class="panel-title">
                                                        <a data-toggle="collapse" data-parent="#mainAccordion" href="#collapseEditor">
                                                            Body
                                                        </a>
                                                    </h4>
                                                </div>

                                                <div id="collapseEditor" class="panel-collapse collapse in">
                                                    <div class="panel-body">
                                                        <div class="row">
                                                            <div class="col-md-8">
                                                                <div class="body-content">
                                                                    <!--<button (click)="insertCustomText()">insert text</button>
                            <button (click)="insertCustomImages()">insert images</button>-->
                                                                    <br />
                                                                    <quill-editor #editor
                                                                                  [(ngModel)]="editorContent"
                                                                                  (blur)="onEditorBlured($event)"
                                                                                  (focus)="onEditorFocused($event)"
                                                                                  (onEditorCreated)="onEditorCreated($event)"
                                                                                  (onContentChanged)="onContentChanged($event)"></quill-editor>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-4">
                                                                <div class="customFields">
                                                                    <div class="panel-group" id="accordion">

                                                                        <div *ngFor="let field of templateFields; let i = index" class="panel panel-default">
                                                                            <div class="panel-heading" data-toggle="collapse">
                                                                                <h4 class="panel-title">
                                                                                    <a data-toggle="collapse" data-parent="#accordion" href="#group{{i}}">{{field.Name}} Details</a>
                                                                                </h4>
                                                                            </div>
                                                                            <div id="group{{i}}" class="panel-collapse collapse" [ngClass]="{'in': i == 0}">
                                                                                <div class="panel-body">
                                                                                    <ul>
                                                                                        <li *ngFor="let item of field.Fields">
                                                                                            <button [disabled]="isStandard" (click)="insertCustomFields(item.Name)">{{item.Name}}</button>
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                            </div>
                                                                        </div>


                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <br />
                                        <br />
                                        <br />
                                    </div>
                                </div>
                                <!--------------------------------main-content END---------------------------------->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*CONFIRMATION DELETE MODAL*/-->
<div id="confirmationDeleteModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Delete Email Template</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p>Are you sure you want to delete this <b>Email Template</b>?</p>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                        <button (click)="deleteEmailTemplate()" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*PREVIEW MODAL*/-->
<div id="coachEmailPreviewModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document" style="width: 80vw;">
        <div class="modal-content" >
            <div class="modal-header">
                <div>
                    <h2 class="modal-title text-center">Email Template Preview</h2>
                    <button (click)="closePreviewModal();" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>

            <div class="modal-body">
                <div id="notCustomizable">
                    <div class="row">
                        <div class="col-md-2 text-right">
                            <label for="subject">Subject: </label>
                        </div>
                        <div class="col-md-10" >
                            <input class="input_readonly" readonly type="text" name="subject" id="prevSubject" value="" style="width: 100%;"/>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2 text-right">
                            <label for="body">Body: </label>
                        </div>
                        <div class="col-md-10">
                            <div class="bodyContainer input_readonly" id="body" style="height: fit-content;"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button (click)="sendPreviewEmail()" type="button" class="btn btn-primary" style="margin-right: 15px;">
                            <span *ngIf="!sendingPreview">Send me a copy</span>
                            <span *ngIf="sendingPreview">
                                <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Sending copy
                            </span>
                        </button>
                        <button *ngIf="customize" (click)="closePreviewModal();" style="margin-right: 25px;" type="button" data-dismiss="modal" class="btn btn-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Send Email Preview Modal -->
<div id="sendPreviewEmailModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Email Preview</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body" >
                <div style="display: flex;align-items: center;margin-bottom: 5px;">
                    <label for="emailAddressInput">Recipient:</label>
                    <input [formControl]="recipientInputControl" type="email" required placeholder="Enter email address" id="emailAddressInput" style="width: 100%;"/>
                </div>
                <span style="color: rgba(255,57,65,.9); margin-left: 80px;" *ngIf="recipientInputControl.hasError('required') && recipientInputControl.dirty">required!</span>
                <span style="color: rgba(255,57,65,.9);  margin-left: 80px;" *ngIf="!recipientInputControl.hasError('required') && recipientInputControl.hasError('email') && recipientInputControl.dirty">invalid format!</span>
                <span *ngIf="!recipientInputControl.dirty || recipientInputControl.valid">&nbsp;</span>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="sendPreviewEmail()" type="button" class="btn btn-primary" style="margin-right: 15px;">
                            <span *ngIf="!sendingPreview">Send</span>
                            <span *ngIf="sendingPreview">
                                <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Sending
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>